import { defineAsyncComponent } from 'vue'
export default {
  debug: defineAsyncComponent(() => import("/builds/leviia/console/layouts/debug.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/leviia/console/layouts/default.vue").then(m => m.default || m))
}